import { AxiosResponse } from "axios";
import {  getAsync, putAsync } from "./client";
import { Contact } from "../@type/contactType";

class ContactService {

  getById = async (): Promise<AxiosResponse> => {
    return await getAsync(`contact/${1}`);
  };

    updateById = async ( data: Contact): Promise<AxiosResponse> => {
      return await putAsync(`contact/${1}`, data);
    };
}

const contactService = new ContactService(); 

export default contactService; 
